var _style, _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 813 518",
    style: {
      enableBackground: "new 0 0 813 518"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 58.5,
    className: "st0",
    width: 720,
    height: 405
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M556.2,424v28H416v-28H556.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.8,214.5v6.2h-27v-5.4c0-9.9-5.4-17.5-19.4-17.5c-11.8,0-17.9,6-17.9,15.1c0,5.4,2.1,9.3,6,12 c3.9,2.7,11.3,6.4,21.9,10.7c14,5.2,23.9,10.9,29.5,16.9c5.6,6,8.5,14.4,8.5,25.4c0,24.7-18.6,39.4-47.6,39.4 c-32.8,0-47.2-15.9-47.2-39.8v-8h27v5.8c0,12.4,6.8,19.2,20.8,19.2c12.6,0,19.4-5.8,19.4-15.1c0-11.3-4.9-14.4-28.9-23.9 c-12.8-4.7-22.1-10.1-28-16.1c-6-6-8.9-14.6-8.9-26c0-22.3,16.9-38.4,46-38.4C196.3,174.9,210.8,191.4,210.8,214.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.9,177.3h27.8v112.2h48.7v25.2h-76.5V177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.9,177.3h28v137.3h-28V177.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M561.4,218.8v8.2h-27v-6.8c0-14-7.4-21.9-19.8-21.9c-13.8,0-21.9,10.3-21.9,26.6v41.9c0,16.3,8,26.8,21.9,26.8 c12.4,0,19.8-7.8,19.8-21.9V265h27v8.2c0,27.2-16.5,44.3-47,44.3c-31.3,0-50.1-19.8-50.1-51.3v-40.4c0-31.5,19.6-51.3,50.7-51.3 C545.7,174.4,561.4,190.9,561.4,218.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M604,177.3h82.3v24.5h-55.1V233h42.9v23.5h-42.9v33.6h55.3v24.5H604V177.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "416,424 51.4,424 51.4,68 752.5,68 752.5,383.3 780.5,383.3 780.5,40 23.3,40 23.3,452 23.3,452  416,452  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlice);
export default __webpack_public_path__ + "static/media/slice.6a58a6d73953e11616636a9068f3c433.svg";
export { ForwardRef as ReactComponent };